// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"componentBase_loadingSpinner__219ge"};